// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_eI7","cls2":"SimplePaperPodcast-cls2_T8Y SimplePaperPodcast-cls1_eI7"};